import { App } from "App";

import "index.css";
import { createRoot } from "react-dom/client";
import "react-quill/dist/quill.snow.css";

const root = createRoot(document.getElementById("root") as HTMLElement);
root.render(<App />);
